import { type Location } from '@koala/sdk';
import { LOCATION_PILL_COPY } from './constants';
import { SelectLocationModal } from './select-location-modal';
import { useLocationPickerState } from './use-location-picker-state';
import { useLocationPillLabel } from './use-location-pill-label';
import { StoreHero } from '@/components/store/hero';
import { K_ANALYTICS_CTA_LOCATIONS } from '@/constants/events';
import { useSelector } from '@/redux';

/**
 * The menu page's location hero image. For multi-location brands it also opens the
 * Select Location pop-up (TEAM-13315). Desktop only, like the hero itself.
 */
export function LocationHero() {
  const { canChange, busy } = useLocationPickerState();
  const detail = useSelector((state) => state.app.locations.detail);

  if (!canChange || !detail) {
    return <StoreHero />;
  }

  return <SelectableHero location={detail} busy={busy} />;
}

function SelectableHero({ location, busy }: { location: Location; busy: boolean }) {
  const label = useLocationPillLabel(location);

  return (
    <SelectLocationModal
      analyticsDetail={K_ANALYTICS_CTA_LOCATIONS.LOCATION_HERO}
      trigger={(open) => (
        <StoreHero
          onSelect={open}
          selectLabel={LOCATION_PILL_COPY.changeLocationLabel(label)}
          disabled={busy}
        />
      )}
    />
  );
}
